import { GridType } from "../../../types/grid";
import { formatString } from "../../../utils/formatString";

export const searchKeys = [
  { value: "name", label: "Name", default: true },
  { value: "phone", label: "Phone" },
  { value: "email", label: "Email" },
  { value: "tradeLicense", label: "Trade License No" },
];

export const gridProps = {
  sortable: true,
  filter: true,
  resizable: true,
  minWidth: 200,
};

export const limit = 20;
export const filterStatus = [
  {
    label: "All",
    value: "all",
  },
  {
    label: "Registered",
    value: "registered",
  },
  {
    label: "Not registered",
    value: "not_registered",
  },
  {
    label: "Inactive/Deleted",
    value: "inactive_deleted",
  },
  {
    label: "Blacklisted",
    value: "isBlocked",
  },
];

export const ownerGridColumn = (
  actions: (params: unknown) => JSX.Element,
  viewBankAccounts: (params: unknown) => void,
  column: GridType[] | null = null,
): GridType[] => {
  if (column && column?.length > 0) {
    return column?.map((col) => {
      if (col.field === "bankAccounts") {
        return {
          ...col,
          maxWidth: 200,
          cellRendererFramework: ({ data }) => viewBankAccounts(data),
        };
      }

      if (col.field === "action") {
        return {
          ...col,
          maxWidth: 200,
          cellRendererFramework: ({ data }) => actions(data),
        };
      }

      return col; // ✅ REQUIRED
    });
  } else {
    return [
      {
        id: "name",
        headerName: "Owner Name",
        field: "name",
        flex: 1,
        minWidth: 180,
        checked: true,
        hide: false,
        cellRenderer: (params) => formatString(params.data.name),
      },

      {
        headerName: "Owner Number",
        field: "number",
        id: "number",
        minWidth: 180,
        flex: 1,
        checked: true,
        hide: false,
      },
      {
        headerName: "Owner Email",
        field: "email",
        minWidth: 180,
        flex: 1,
        id: "email",
        checked: true,
        hide: false,
      },
      {
        headerName: "Nationality",
        field: "nationality",
        minWidth: 180,
        flex: 1,
        id: "nationality",
        cellRenderer: (params) => formatString(params.data.nationality),
        checked: true,
        hide: false,
      },
      {
        headerName: "City",
        field: "city",
        minWidth: 180,
        flex: 1,
        cellRenderer: (params) => formatString(params.data.city),
        id: "city",
        checked: true,
        hide: false,
      },
      {
        headerName: "Phone Number",
        field: "phone",
        minWidth: 180,
        flex: 1,
        id: "phone",
        checked: true,
        hide: false,
      },
      {
        headerName: "Bank Accounts",
        field: "bankAccounts",
        minWidth: 180,
        flex: 1,
        cellRendererFramework: viewBankAccounts,
        id: "bankAccounts",
        checked: true,
        hide: false,
      },
      {
        headerName: "Note",
        field: "note",
        minWidth: 180,
        flex: 1,
        id: "note",
        checked: true,
        hide: false,
      },
      {
        headerName: "POC Email",
        field: "pocEmail",
        minWidth: 180,
        flex: 1,
        id: "pocEmail",
        checked: true,
        hide: false,
      },
      {
        headerName: "POC Name",
        field: "pocName",
        minWidth: 180,
        flex: 1,
        id: "pocName",
        checked: true,
        hide: false,
      },
      {
        headerName: "POC Phone",
        field: "pocPhone",
        minWidth: 180,
        flex: 1,
        id: "pocPhone",
        checked: true,
        hide: false,
      },
      {
        headerName: "POC Work Phone",
        field: "pocWorkPhone",
        minWidth: 180,
        flex: 1,
        id: "pocWorkPhone",
        checked: true,
        hide: false,
      },
      {
        headerName: "Action",
        field: "action",
        cellRendererFramework: actions,
        checked: true,
        id: "action",
        hide: false,
        minWidth: 60,
        flex: 1,
        pinned: "right",
      },
    ];
  }
  //  return column;
};
